/*
 * Copyright (C) 2019 Robert Bosch GmbH Copyright (C) 2019 Robert Bosch Manufacturing Solutions GmbH, Germany. All rights reserved.
 */

import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";

@Component({
    selector: "bci-sidebar-nav-item-overlay",
    templateUrl: "./bci-sidebar-nav-item-overlay.component.html",
    styleUrls: ["./bci-sidebar-nav-item-overlay.component.scss"],
    standalone: false
})
export class BciSidebarNavItemOverlayComponent implements OnInit {
  /**
   * Informs that the component wishes to be closed. Used by the overlay handler.
   */
  /*tslint:disable-next-line:no-output-native*/
  @Output()
  close: EventEmitter<void> = new EventEmitter<void>();

  @Input()
  showClose = true;

  constructor() {}

  ngOnInit() {}

  clickClose() {
    this.close.emit();
  }
}
